import script from "./NewClassifierRule.vue?vue&type=script&setup=true&lang=js"
export * from "./NewClassifierRule.vue?vue&type=script&setup=true&lang=js"

import "./NewClassifierRule.vue?vue&type=style&index=0&id=aea7dbee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aea7dbee"]])

export default __exports__